import Vue from 'vue'
import App from './App.vue'
import VTooltip from 'v-tooltip'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'

Vue.use(VTooltip)
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
